export default function HomeSubtitle(props) {
  return (
    <h3 className="text-xl md:text-2xl lg:text-3xl font-black pb-4">
      {props.children}
    </h3>
  );
}
